
import { HubConnection, HubConnectionBuilder } from '@microsoft/signalr';
import Vue from "vue";
import { Component, Prop } from "vue-property-decorator";
import Toasted from 'vue-toasted';
import { KanbanState } from "./kanban.model";

Vue.use(Toasted, { duration: 2000 });

@Component({
  name: 'SignalR',
  components: {
  },
})
export default class SignalR extends Vue {
  @Prop({ required: true })
  readonly state!: KanbanState;
  
  private signalRCon!: HubConnection;

  created(): void {
    this.initSignalR();
  }

  beforeDestroy(): void {
    if (this.signalRCon) {
      this.signalRCon.stop();
    }
  }

  private initSignalR(): HubConnection {
    const connection = new HubConnectionBuilder()
        .withUrl("kanbanHub")
        .build();
    connection.on("KanbanUpdateInfo", (user, message) => {
      const msg = message.replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;");
      const encodedMsg = `${user}: ${msg}`;
      console.log(encodedMsg);
      //this.$toasted.info(encodedMsg);
      this.$toasted.info(encodedMsg, {
        action: { // action close click, see https://github.com/shakee93/vue-toasted#usage
          text: 'x',
          onClick: (e, toastObject) => {
            toastObject.goAway(0);
          }
        },
        duration: 10000
      });
    });
    connection.on("KanbanUpdate", () => {
      this.state.updates++;
    });
    connection.start().catch(err => console.error(err));
    return connection;
  }
}
